import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import style from "./toast.module.sass";
import { useToast, removeToast, IToast } from "../../context/ToastContext";

interface ToastProps {
  closeIn: number;
  from: string;
}

export const Toast: React.FC<ToastProps> = ({ closeIn, from }) => {
  const {
    state: { toasts },
    dispatch: toastDispatch,
  } = useToast();
  const mountNode = document.getElementById(from === "studio" ? "popup-root" : "a8DataToast");

  const handleRemoveToast = (toastId: string) => {
    toastDispatch(removeToast(toastId))
  };

  // remove toast after a short duration
  useEffect(() => {
    const interval = setInterval(() => {
      if(toasts.length) {
        const toastId = toasts[toasts.length - 1].id
        toastDispatch(removeToast(toastId))
      }
    }, closeIn);

    if (!toasts.length) {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [toasts]);

  return createPortal(
    <div className={style.toastContainer}>
      {toasts.map((toast: any) => (
        <ToastMessage toast={toast} key={toast.id} removeToast={handleRemoveToast} />
      ))}
    </div>,
    mountNode as Element
  );
};

interface ToastMessageProps {
  toast: IToast;
  removeToast: (toastId: string) => void;
}

const ToastMessage: React.FC<ToastMessageProps> = ({ toast, removeToast }) => {
  const toTitleCase = (str: string) => str[0].toUpperCase() + str.substr(1);

  return (
    <div className={style.toast + " " + style[toast.type]}>
      <span
        className={style.toastClose}
        onClick={() => removeToast(toast.id)}
      >
        X
      </span>
      <p className={style.toastMessage}>{toTitleCase(toast.type)}</p>
      <p className={style.toastSubmessage}>{toast.message}</p>
    </div>
  );
};
